var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                ref: "tabs",
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_FlightConfig"],
                        expression: "['tab_FlightConfig']"
                      }
                    ],
                    key: "flightList",
                    attrs: {
                      name: "flightList",
                      label: _vm.$t("CargoMsg.Cargo_Flight"),
                      lazy: true
                    }
                  },
                  [_c("flight-list")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_AirTransitRoutingConfig"],
                        expression: "['tab_AirTransitRoutingConfig']"
                      }
                    ],
                    key: "airTransitRoutingList",
                    attrs: {
                      name: "airTransitRoutingList",
                      label: _vm.$t("queryJob.line"),
                      lazy: true
                    }
                  },
                  [_c("air-transit-routing-list")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_AirRegion"],
                        expression: "['tab_AirRegion']"
                      }
                    ],
                    key: "airRegionList",
                    attrs: {
                      name: "airRegionList",
                      label: _vm.$t("queryJob.airTransportArea"),
                      lazy: true
                    }
                  },
                  [_c("air-region-list")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_AirRoute"],
                        expression: "['tab_AirRoute']"
                      }
                    ],
                    key: "airRouteList",
                    attrs: {
                      name: "airRouteList",
                      label: _vm.$t("CargoMsg.Cargo_Airline"),
                      lazy: true
                    }
                  },
                  [_c("air-route-list")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_OperationResponsibility"],
                        expression: "['tab_OperationResponsibility']"
                      }
                    ],
                    key: "operationResponsibilityList",
                    attrs: {
                      name: "operationResponsibilityList",
                      label: _vm.$t("queryJob.operationalResponsibilities"),
                      lazy: true
                    }
                  },
                  [_c("operation-responsibility-list")],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["tab_OperationResponsibilityAssign"],
                        expression: "['tab_OperationResponsibilityAssign']"
                      }
                    ],
                    key: "operationResponsibilityAssign",
                    attrs: {
                      name: "operationResponsibilityAssign",
                      label: _vm.$t("queryJob.assignmentOfResponsibilities"),
                      lazy: true
                    }
                  },
                  [_c("operation-responsibility-assign")],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }